// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__X7bMp","imageUploader":"EGiftCard_imageUploader__3tHYq"};